import  { useEffect, useState } from "react";
import "./FourthReport.css";

const QTag = ({ q, a, impacts }) => (
  <div style={{display:'flex',flexWrap:'wrap',gap:'5px 10px',alignItems:'center',background:'#f0f4ff',border:'1px solid #c7d7fa',borderRadius:'6px',padding:'7px 12px',marginBottom:'12px',fontSize:'12px',lineHeight:1.5}}>
    <span style={{background:'#3b5bdb',color:'#fff',fontWeight:700,padding:'2px 8px',borderRadius:4,fontSize:'10px',whiteSpace:'nowrap'}}>📋 FORM QUESTION</span>
    <span style={{color:'#1e3a8a',fontStyle:'italic'}}>"{q}"</span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#047857',fontWeight:700}}>You answered: <strong>{a}</strong></span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#7c3aed',fontSize:'11px'}}>📊 Impacts: {impacts}</span>
  </div>
);

const FourthReport = ({ res }) => {
  const [maturityValue, setMaturityValue] = useState("");
  const [problemKind, setProblemKind] = useState("");

  useEffect(() => {
    const storedMaturity = res.productMaturity || "";
    const storedProblem = res.problemKind || "";

    if (storedMaturity) setMaturityValue(storedMaturity);
    if (storedProblem) setProblemKind(storedProblem);
  }, [res]);

  // Normalize to lowercase for case-insensitive comparison
  const pk = problemKind.toLowerCase();

  const problemContent =
    pk === "every problem in oriented areas"
      ? "A good entrepreneur solves every problem in one area, but a great entrepreneur identifies and solves a unique, high-impact problem that spans across oriented areas or industries."
      : pk === "unique problem in oriented areas"
      ? "We aim to follow the great entrepreneur model — focusing on innovation, scalability, and creating long-term value through unique solutions that transform multiple sectors."
      : "";

  // Case-insensitive maturity map
  const maturityData = {
    "idea stage": {
      nextStep: "Develop PoC, validate demand, then apply for incubation.",
      investor: "Very Early – focus on idea refinement and validation."
    },
    "poc-mvp": {
      nextStep: "Demonstration that your idea can technically work.",
      investor: "Incubators love this; investors start to take interest."
    },
    "pmf": {
      nextStep: "Product validated by paying customers or growing users.",
      investor: "Ideal for seed or Series-A investment."
    },
    "scaling stage": {
      nextStep: "Expanding to new markets or adding new features.",
      investor: "Very attractive — ready for large investment."
    }
  };

  // Case-insensitive key match
  const maturityKey = maturityValue.toLowerCase();
  const selectedMaturity = maturityData[maturityKey] || {};

  return (
   <>
   <QTag
     q="What type of problem are you solving — every problem in a niche, or one unique high-impact problem? What is your product's current development stage?"
     a={`Problem type: ${problemKind || "—"} · Product stage: ${maturityValue || "—"}`}
     impacts="Problem-market fit score, funding readiness, incubation eligibility, investor milestone expectations"
   />
   <div style={{ padding: "10px" }}>

  {/* =============== TABLE 3A =============== */}
 {problemKind && (
  <div className="fourth-table-wrapper">

    {/* CORNERS OUTSIDE TABLE */}
    <span className="corner top-left"></span>
    <span className="corner top-right"></span>
    <table className="fourth-table">
      <thead>
        <tr>
          <th colSpan="4" className="module4-title">
             <span className="module-prefix">Module 3:</span>  Value Proposition & Hypothesis Testing
          </th>
        </tr>
      </thead>
      

      <tbody>
        <tr>
          <td className="serial-cell">3 A</td>
          <td>{problemKind}</td>
          <td colSpan="2">{problemContent}</td>
        </tr>
      </tbody>
    </table>
  </div>
)}


  {/* =============== TABLE 3B =============== */}
  <div className="fourth-table-wrapper" style={{ marginTop: "15px" }}>

  {/* CORNERS OUTSIDE TABLE */}
  <span className="corner bottom-left"></span>
  <span className="corner bottom-right"></span>

  <table className="fourth-table">
    <tbody>
      <tr>
        <td className="serial-cell">3 B</td>
        <td>{maturityValue}</td>
        <td>{selectedMaturity.nextStep || "-"}</td>
        <td>{selectedMaturity.investor || "-"}</td>
      </tr>
    </tbody>
  </table>
</div>


</div>
   </>
  );
};

export default FourthReport;
